import React, { useEffect, useState } from 'react'
import { User } from '../../../models/User'
import styled from 'styled-components'
import { ResultJobsEvaluation } from '../../../models/ResultJobsEvaluation'
import { ResultJobsDto } from '../../../models/Dto/ResultJobsDto'
import { ActiveProps, GrayButton } from '../../Layout/CommonStyle'
import { ResultJobsEvaluationsDto } from '../../../models/Dto/ResultJobsEvaluationsDto'
import { IconButton } from '@mui/material'
import { MdOutlineClose } from 'react-icons/md'
import axios from 'axios'
import { axiosPost } from '../../Common/Axios'
import { ApiResult } from '../../../models/Enums'
import toast from 'react-hot-toast'

interface Props {
  resultJobsEvaluationsDto: ResultJobsEvaluationsDto
  resultJobsEvaluationsDtos: ResultJobsEvaluationsDto[]
  setResultJobsEvaluationsDtos: (
    resultJobsEvaluationsDtos: ResultJobsEvaluationsDto[]
  ) => void
  setResultJobsEvaluationsDto: (
    resultJobsEvaluationsDto: ResultJobsEvaluationsDto
  ) => void
  setIsPopup: (isPopup: boolean) => void
  useDelete: boolean
}

function ResultJob({
  resultJobsEvaluationsDto,
  resultJobsEvaluationsDtos,
  setResultJobsEvaluationsDtos,
  setResultJobsEvaluationsDto,
  setIsPopup,
  useDelete,
}: Props) {
  const handleDelete = async (resultJobsId: number) => {
    if (!confirm('삭제하시겠습니까?')) {
      return
    }

    const result = await axiosPost('/api/jobs/delete_result_jobs', resultJobsId)
    if (result.apiResult !== ApiResult.SUCCESS) {
      console.log('delete_result_jobs error', result.message)
      toast.error('삭제에 실패했습니다')
      return
    }
    setResultJobsEvaluationsDtos(
      resultJobsEvaluationsDtos.filter((r) => r.resultJobs.id !== resultJobsId)
    )
    toast.success('삭제되었습니다')
  }

  return (
    <Container>
      <img
        onClick={() => {
          setResultJobsEvaluationsDto(resultJobsEvaluationsDto)
          setIsPopup(true)
        }}
        src={
          process.env.PUBLIC_URL + resultJobsEvaluationsDto.resultJobs.posterUrl
        }
      />
      <Info>
        <h3>{resultJobsEvaluationsDto.resultJobs.jobName}</h3>
        <div>{resultJobsEvaluationsDto.resultJobs.jobContent}</div>
      </Info>
      <Evaluate>
        <EvaluateUnit>
          <div>구체성</div>
          <div>
            {resultJobsEvaluationsDto.resultJobsEvaluations.reduce(
              (acc, curr) => acc + curr.concreteness,
              0
            )}
          </div>
        </EvaluateUnit>
        <EvaluateUnit>
          <div>흥미</div>
          <div>
            {resultJobsEvaluationsDto.resultJobsEvaluations.reduce(
              (acc, curr) => acc + curr.interest,
              0
            )}{' '}
          </div>
        </EvaluateUnit>
        <EvaluateUnit>
          <div>사회적 필요성</div>
          <div>
            {resultJobsEvaluationsDto.resultJobsEvaluations.reduce(
              (acc, curr) => acc + curr.need,
              0
            )}{' '}
          </div>
        </EvaluateUnit>
        <EvaluateUnitTotal>
          <div>총점</div>
          <div>
            {resultJobsEvaluationsDto.resultJobsEvaluations.reduce(
              (acc, curr) =>
                acc + curr.concreteness + curr.interest + curr.need,
              0
            )}
            점
          </div>
        </EvaluateUnitTotal>
      </Evaluate>
      {useDelete && (
        <IconButton
          onClick={() => handleDelete(resultJobsEvaluationsDto.resultJobs.id)}
        >
          <MdOutlineClose />
        </IconButton>
      )}
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  border: 1px solid #aaa;
  margin-bottom: 10px;
  position: relative;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    border: none;
    border-bottom: 1px solid #aaa;
  }

  img {
    width: 250px !important;
    min-width: 250px;

    @media (max-width: 768px) {
      width: 95%;
      min-width: 95%;
      box-sizing: border-box;
    }
  }

  & > button {
    position: absolute;
    top: 0px;
    right: 0px;
  }
`

const Info = styled.div`
  width: 100%;
  padding: 20px;
  border-left: 1px solid #aaa;
  border-right: 1px solid #aaa;
  h3 {
    padding-bottom: 10px;
    font-size: 1.2rem;
  }
  div {
    word-wrap: break-word;
    overflow-wrap: break-word;
    width: 100%;
    line-height: 1.4rem;
  }
  pre {
    font-size: 1rem;
    margin: 0;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  @media (max-width: 768px) {
    padding: 30px 10px;
    box-sizing: border-box;
    border: none;
  }
`

const Evaluate = styled.div`
  width: 350px;
  padding: 20px 10px;

  @media (max-width: 768px) {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
  }
`

const EvaluateUnit = styled.div`
  padding-bottom: 10px;
  display: flex;
  flex-direction: row;
  & > div:nth-child(1) {
    width: 120px;
    text-align: justify;
  }
`

const EvaluateUnitTotal = styled.div`
  margin-top: 20px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: row;
  font-weight: bold;
  & > div:nth-child(1) {
    width: 120px;
    text-align: justify;
  }
`

// const PointButton = styled.button<{ selected?: boolean }>`
const PointButton = styled.button`
  margin-right: 3px;
  padding: 3px 8px;
  background-color: ${(props: ActiveProps) =>
    props.active ? 'tomato' : 'white'};
  color: ${(props: ActiveProps) => (props.active ? 'white' : 'black')};
`

export default ResultJob
